var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_4570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8307 15.9043L9.43213 19.3555H16.2876L14.6071 15.9043",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.765 4.75928H4.95813V15.4598H20.765V4.75928Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.111 33.7896L25.7124 37.2408H32.5678L30.8874 33.7896",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0418 22.6445H21.2349V33.3451H37.0418V22.6445Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5792 36.2069C15.5792 36.2069 9.41763 33.2869 8.32263 28.0396L8.14917 27.2012",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4089 28.4805L7.69745 25.4521L5.51831 29.5466",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5906 5.99902C26.5906 5.99902 32.7522 8.919 33.8472 14.1663L34.0206 15.0047",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.761 13.7253L34.4724 16.7537L36.6479 12.6592",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_4570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonDataIcon);
export default __webpack_public_path__ + "static/media/CommonDataIcon.5df0e3d28dbdd99f4a911e88b6da6d93.svg";
export { ForwardRef as ReactComponent };